import { setDataset, setProject, setProjectDiscoveryDates, setProjectFireCodes, setProjectIDs } from '../redux/slices/filterSlice';
import { setViewingActions, setViewingProjects } from '../redux/slices/menuSlice';
import store from '../redux/store';
import FieldNames from '../defaults/FieldNames.json';

// ------
//  Redux Fetch Calls
// ------

export const getAppConfig = () => {
  //console.log(store.getState()); // To view all redux values
  return store?.getState()?.configuration?.config;
}

export const getNifcToken = () => {
  return store?.getState()?.configuration?.nifcToken;
}

export const getAttributeServiceUrl = () => {
  return store?.getState()?.configuration?.rootServiceUrl;
}

export const getViewServiceUrl = () => {
  return store?.getState()?.configuration?.viewRootServiceUrl;
}

export const getSummaryViewRootServiceUrl = () => {
  return store?.getState()?.configuration?.summaryViewRootServiceUrl;
}

export const getFilterState = () => {
  return store?.getState()?.filter;
}

export const getCustomFilterState = () => {
  return store?.getState()?.customFilter;
}

export const getProjectState = () => {
  return store?.getState()?.projects;
}

export const getMapState = () => {
  return store?.getState()?.map;
}

export const getMenuState = () => {
  return store?.getState()?.menu;
}

// ------
//  Redux Update Calls
// ------

// Generic Update Method
export const updateStore = (dispatchMethod, value) => {
  // Note: This is a synchronous operation
  store?.dispatch(dispatchMethod(value));
}

export const resetProjectCacheValues = () => {
  // Reset Action/Project list card radio selection
  store?.dispatch(setViewingActions(true));
  store?.dispatch(setViewingProjects(false));
}

export const resetPostFireCacheValuesToFuels = () => {
  store?.dispatch(setDataset(FieldNames.datasets.fuels));
  store?.dispatch(setProject([]));
  store?.dispatch(setProjectDiscoveryDates([]));
  store?.dispatch(setProjectIDs([]));
  store?.dispatch(setProjectFireCodes([]));
}

export const resetPostFireCustomFiltersToFuels = (userInfo) => {
  // TODO: Implement when we receive an official story for it
}

export const resetFuelsCacheValuesToPostFire = () => {
  store?.dispatch(setDataset(FieldNames.datasets.postfire));
}

export const resetFuelsCustomFiltersToPostFire = (userInfo) => {
  // TODO: Implement when we receive an official story for it
}


// placing this in here because it is currently used in redux to reset state
export function resetPropertiesToDefaultWithExclusions(state, initialState, exclude = [], defaultValue = undefined) {
    for (const prop in state) {
        if (!exclude.includes(prop)) {
            if (initialState[prop] !== null) {
                if (defaultValue !== undefined) {
                    state[prop] = defaultValue;
                } else {
                    state[prop] = initialState[prop];
                }
            } else {
                delete state[prop];
            }
        }
    }
}
